import { render } from "./MenuLateralDashV2.vue?vue&type=template&id=17f36223&scoped=true"
import script from "./MenuLateralDashV2.vue?vue&type=script&lang=js"
export * from "./MenuLateralDashV2.vue?vue&type=script&lang=js"

import "./MenuLateralDashV2.vue?vue&type=style&index=0&id=17f36223&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f36223"]])

export default __exports__